import Curl from '$common/utils/curl/browser-curl';
import UrlModules from '$common/utils/curl/browser-curl/url-modules';
import { gateway_web as pix } from '../api-pix';
const appgatewayHost = new UrlModules({ module: 'appgateway' });
const defaultCurl = (params, url, config) => new Curl().curl(params, `${appgatewayHost.host}/${pix}/${url}`, config);

/**
 * 查询门店详情
 * @param {*} params
 */
export const getStoreDetail = (params, config) => defaultCurl(params, `app/mobile-app-composition/get/store/detail`, config);


/**
 * 获得背景图
 * @param {*} params
 */
 export const getImagePath = (params, config) => defaultCurl(params, `takeaway-merchant/app/super-app/getImagePath`, config);


 
/**
 * 获得配送费优惠金额
 * @param {*} params
 */
 export const getDiscountFee = (params, config) => defaultCurl(params, `app/marketing/findDeliveryFeeReduceAvailableActivity.do`, config);


  
/**
 * 获得门店活动
 * @param {*} params
 */
 export const getPromotionList = (params, config) => defaultCurl(params, `takeaway-merchant/app/h5/share-store-activity-list`, config);
